/* eslint-disable react/require-default-props */
import React from 'react';
import { CheckboxList } from '../../../CheckboxList';
import { Radio } from '../../../Radio';
import './ControlGroupChildrenStyles.scss';
/**
 * ControlGroupChildren Component
 * Renders the children list with a visual hierarchy line.
 * Composes CheckboxList or Radio for the actual control rendering.
 * @version 1.0.0
 * @since 2026-03-09
 */
export function ControlGroupChildren({ childrenControlType, items, selectedValues, onCheckboxToggle, onRadioChange, disabled = false, name = '' }) {
    const containerClass = ['qmb-ui-control-group-children', disabled ? 'qmb-ui-control-group-children--disabled' : '']
        .filter(Boolean)
        .join(' ');
    return (React.createElement("div", { className: containerClass },
        React.createElement("div", { className: "qmb-ui-control-group-children__content" },
            childrenControlType === 'checkbox' && (React.createElement(CheckboxList, { options: items.map((child) => ({
                    title: child.label,
                    value: child.value,
                    description: child.description,
                    disabled: child.disabled
                })), value: selectedValues, onChange: onCheckboxToggle, disabled: disabled })),
            childrenControlType === 'radio' && (React.createElement(Radio, { name: name, options: items.map((child) => ({
                    value: child.value,
                    label: child.label,
                    description: child.description,
                    disabled: child.disabled
                })), value: selectedValues[0] || '', onChange: onRadioChange, disabled: disabled })))));
}
